import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {PAGINATION_STYLE} from '@aviary/injection-tokens/app-provided.tokens';
import {PaginationStyle} from '@aviary/components/table/table.component.types';

export function provideAviaryPaginatorSettings(paginationStyle: PaginationStyle): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: PAGINATION_STYLE, useValue: paginationStyle}
  ]);
}
